import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Fetch Dashboard Stats
export const fetchDashboardStats = createAsyncThunk(
  'adminDashboard/fetchStats',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/admin-dashboard/stats');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch dashboard stats');
    }
  }
);

// Fetch Employee Details
export const fetchEmployeeDetails = createAsyncThunk(
  'adminDashboard/fetchEmployeeDetails',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/admin-dashboard/employees');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch employee details');
    }
  }
);

// Fetch Employees with Birthdays Today
export const fetchEmployeesWithBirthdayToday = createAsyncThunk(
  'adminDashboard/fetchBirthdays',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/admin-dashboard/employees/birthday');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch birthday employees');
    }
  }
);

// Fetch Employees Stats By employee id

export const fetchEmployeeStats = createAsyncThunk(
  'adminDashboard/fetchEmployeeStats',
  async (employeeId: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/admin-dashboard/employees/${employeeId}/stats`);
      return response.data; 
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch employee stats');
    }
  }
);


export const fetchEmployeePunchStats = createAsyncThunk(
  'adminDashboard/fetchEmployeePunchStats',
  async (employeeId: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/admin-dashboard/employees/${employeeId}/punch`);
      return response.data; 
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch employee stats');
    }
  }
);
export const fetchEmployeeLeaveToday = createAsyncThunk(
  'adminDashboard/fetchEmployeeLeaveToday',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/admin-dashboard/employees/today/leave`);
      return response.data; 
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch employee stats');
    }
  }
);
